(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.services')
		.service('UserService', UserService)

	/** @ngInject */
	function UserService($q, $rootScope, $httpParamSerializerJQLike, HttpService, APP) {
		let userData;

		const UserService = {
			// Getters
			verifyRegister,
			getUserData,
			getUserAccessToLocation,
			getUser,
			getUserId,
			getUserRescues,

			// Setters
			post,
			saveLocalUserData,
			saveUserAccessToLocation,
			put,
			putPassword,

			// Actions
			login,
			getFacebookLoginUrl,
			loginWithFacebook,
			getGoogleLoginUrl,
			loginWithGoogle,
			logout,
			handleSystemLoad,
			isLogged,
			recoverPassword,
			verifyPasswordToken,
			verifyPasswordToken,
			changePassword
		};

		return UserService;

		// Getters
		function verifyRegister(userData) {
			return HttpService.post('/user/verify-register', userData);
		}

		function getUserData(userId) {
			return HttpService.get(`/user/${userId}`);
		}

		function getUserRescues(userId, params) {
			let serializedParams = $httpParamSerializerJQLike(params);
			return HttpService.get(`/user/${userId}/rescues?${serializedParams}`);
		}

		function getUser() {
			return JSON.parse(localStorage.getItem(`userData${APP.IDENTIFIER}`));
		}

		function getUserId() {
			if (localStorage.getItem(`userId${APP.IDENTIFIER}`))
				return localStorage.getItem(`userId${APP.IDENTIFIER}`);

			return false;
		}

		function getUserAccessToLocation() {
			if (localStorage.getItem(`userAllowLocation${APP.IDENTIFIER}`))
				return localStorage.getItem(`userAllowLocation${APP.IDENTIFIER}`);

			return null;
		}

		// Setters
		function post(userData) {
			return HttpService.post('/user', userData);
		}

		function put(userData) {
			return HttpService.put('/user', userData);
		}

		function putPassword(userData) {
			return HttpService.put('/user/password', userData);
		}

		function saveLocalUserData(userData) {
			if (localStorage.getItem(`userData${APP.IDENTIFIER}`))
				localStorage.removeItem(`userData${APP.IDENTIFIER}`)

			localStorage.setItem(`userData${APP.IDENTIFIER}`, JSON.stringify(userData))
		}

		function saveUserAccessToLocation(permission) {
			if (localStorage.getItem(`userAllowLocation${APP.IDENTIFIER}`))
				localStorage.removeItem(`userAllowLocation${APP.IDENTIFIER}`)

			localStorage.setItem(`userAllowLocation${APP.IDENTIFIER}`, permission)
		}

		// Actions
		function login(userData) {
			let defer = $q.defer();

			HttpService
				.post('/user/login', userData)
				.then(success => {
					if (success.errors)
						defer.reject(success);

					localStorage.setItem(`userId${APP.IDENTIFIER}`, success.UserId);
					saveLocalUserData(success.UserData);
					prepareUserData(success.UserData, defer);
				}, error => {
					defer.reject(error);
				})

			return defer.promise;
		}

		function recoverPassword(userData) {
			return HttpService.post('/user/recover-password', userData);
		}

		function verifyPasswordToken(userId, passwordToken) {
			return HttpService.get(`/user/verify-password-token/${userId}/token/${passwordToken}`);
		}

		function changePassword(userData) {
			return HttpService.post('/user/change-password', userData);
		}

		function logout() {
			let defer = $q.defer();

			localStorage.removeItem(`userId${APP.IDENTIFIER}`);
			localStorage.removeItem(`userData${APP.IDENTIFIER}`);

			defer.resolve();

			return defer.promise;
		}

		function handleSystemLoad() {
			let defer = $q.defer();
			const userId = localStorage.getItem(`userId${APP.IDENTIFIER}`);

			if (userId) {
				getUserData(userId)
					.then(success => {
						prepareUserData(success, defer);
					}, error => {
						defer.reject(error);
					})
			} else {
				defer.reject({
					error: 'ID do usuário não disponivel.'
				});
			}

			return defer.promise;
		}

		function isLogged() {
			if (getUser() && getUserId())
				return true;
			else
				return false;
		}

		function getFacebookLoginUrl() {
			return HttpService.post('/user/login-facebook', [])
		}

		function loginWithFacebook(returnData) {
			let defer = $q.defer();

			HttpService
				.post(`/oauth2callback/facebook?${returnData}`)
				.then(success => {
					if (success.errors)
						defer.reject(success);

					localStorage.setItem(`userId${APP.IDENTIFIER}`, success.UserId);
					saveLocalUserData(success.UserData);
					prepareUserData(success.UserData, defer);
				}, error => {
					defer.reject(error);
				})

			return defer.promise;
		}

		function getGoogleLoginUrl() {
			return HttpService.post('/user/login-google', [])
		}

		function loginWithGoogle(returnData) {
			let defer = $q.defer();

			HttpService
				.post(`/oauth2callback/google?${returnData}`)
				.then(success => {
					console.log('success oauth2callback: ', success);
					if (success.errors)
						defer.reject(success);

					localStorage.setItem(`userId${APP.IDENTIFIER}`, success.UserId);
					saveLocalUserData(success.UserData);
					prepareUserData(success.UserData, defer);
				}, error => {
					defer.reject(error);
				})

			return defer.promise;
		}

		// Internal
		function prepareUserData(data, defer) {
			userData = data;
			$rootScope.isLogged = true;

			//If we don't have user data or user units go to not authorized
			if (!userData) {
				$rootScope.isLogged = false;

				defer.reject({
					error: 'O usuário não possui dados.',
					redirTo: 'app.login'
				});

				return defer.promise;
			}

			defer.resolve({ Success: true });
		}
	}
}());